<template>
  <div class="index">
    <headCom :styleOption="style"></headCom>
    <swiper :options="swiperOption" ref="mySwiper">
      <!-- slides -->
      <swiper-slide v-for="(item, index) in imgslist" :key="index">
        <img :src="item.img" :class="`swiper-img${index} swiper-img`" />
        <div :class="`page-text${index} page-text`">
          <img :src="item.pageText" alt="" />
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
// import animate from animate.css
import headCom from "@/components/head";
export default {
  name: "Index",
  inject: ["reload"],
  components: {
    headCom,
  },
  data() {
    return {
      screenHeight: document.body.clientHeight,
      swiperOption: {
        loop: false,
        autoplay: 3000,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        notNextTick: true,
        direction: "vertical",
        setWrapperSize: true,
        autoHeight: true,
        slidesPerView: 1,
        mousewheel: true,
        mousewheelControl: true,
        height: window.innerHeight,
        resistanceRatio: 0,
        observeParents: true,
        autoplayDisableOnInteraction: false
      },
      imgslist: [
        { id: 1, img: "static/bg1.png", pageText: "static/img1.png" },
        { id: 2, img: "static/bg2.png", pageText: "static/img2.png" },
        { id: 3, img: "static/bg3.png", pageText: "static/img3.png" },
        { id: 4, img: "static/bg4.png", pageText: "static/img4.png" }
      ],
      show: true,
      style:{
        "position":"fixed",
      }
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    
  }
};
</script>
<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
}
.swiper-container img {
  width: 100%;
  height: 100%;
}
.swiper-pagination {
  left: 10px;
}
/deep/ .swiper-pagination-bullet-active {
  height: 20px;
  background: #fff;
  border-radius: 15px;
}
/deep/ .swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
}
.swiper-slide-active .swiper-img0 {
  animation: enlarge 10s linear 0s;
}
.swiper-slide-active .swiper-img1 {
  animation: narrow 10s linear 0s;
}
.swiper-slide-active .swiper-img2 {
  animation: enlarge 10s linear 0s;
}
.swiper-slide-active .swiper-img3 {
  animation: narrow 10s linear 0s;
}
@keyframes enlarge {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(2);
  }
}
@keyframes narrow {
  0% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
.swiper-slide {
  position: relative;
}
.page-text0 {
  width: 44%;
  position: absolute;
  left: 50%;
  top: 12%;
  margin-left: -22%;
}
.page-text1 {
  width: 23%;
  position: absolute;
  left: 10%;
  top: 27%;
}
.page-text2 {
  width: 26%;
  position: absolute;
  left: 10%;
  top: 28.5%;
}
.page-text3 {
  width: 27%;
  position: absolute;
  left: 10%;
  top: 37.5%;
}
.page-text img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue